export default "__VITE_ASSET__NoFj8JML__"